import React from 'react';
import { motion } from 'framer-motion';
export function PainPoints() {
  return <section className="py-20 md:py-28 px-4 bg-brand-darker border-y border-brand-gray" data-id="element-77">
      <div className="max-w-4xl mx-auto" data-id="element-78">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-79">
          <span className="inline-block text-brand-orange font-bold tracking-widest text-xs md:text-sm uppercase mb-4" data-id="element-80">
            — El Momento de la Verdad —
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-white uppercase" data-id="element-81">
            Mírate al espejo.
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-6 text-lg md:text-xl text-brand-text leading-relaxed max-w-3xl mx-auto" data-id="element-82">
          <p data-id="element-83">
            Mira el éxito que has construido con años de esfuerzo. Tienes los
            recursos, tienes la experiencia y tienes el respeto de los demás.
            Pero,{' '}
            <strong className="text-white" data-id="element-84">
              ¿tienes la energía para disfrutarlo?
            </strong>
          </p>
          <p data-id="element-85">
            Si te despiertas cada mañana sintiendo que operas con un motor a
            medio gas… si la{' '}
            <em className="text-brand-orange not-italic font-semibold" data-id="element-86">
              "neblina cerebral"
            </em>{' '}
            se ha convertido en tu compañera de oficina… si ese fuego interno
            que solía impulsarte a dominar cada proyecto se ha vuelto una ceniza
            tibia…
          </p>
          <p className="text-2xl md:text-3xl font-display font-bold text-white uppercase pt-4 border-l-4 border-brand-orange pl-6" data-id="element-87">
            Tu software hormonal está dañado.
          </p>
          <p className="text-brand-muted" data-id="element-88">
            Y no se va a arreglar con otra taza de café o simplemente "echándole
            ganas".
          </p>
        </motion.div>
      </div>
    </section>;
}